module.exports = __webpack_public_path__ + "static/media/IMG_3560.56849f0c.jpg";